import { render, staticRenderFns } from "./TCFDReport.vue?vue&type=template&id=43edfb88&scoped=true&"
import script from "./TCFDReport.vue?vue&type=script&lang=js&"
export * from "./TCFDReport.vue?vue&type=script&lang=js&"
import style0 from "./TCFDReport.vue?vue&type=style&index=0&id=43edfb88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43edfb88",
  null
  
)

export default component.exports